import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import WgptEventAutomationsAPI from '../../api/wgpt/eventAutomations';
import types from '../mutation-types';
import { throwErrorMessage } from '../utils/api';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,
  },
};

export const getters = {
  getEventAutomations($state) {
    return $state.records;
  },
  getEventAutomation: $state => id => {
    const record = $state.records.find(r => r.id === Number(id));
    return record || {};
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_WGPT_EVENT_AUTOMATIONS_UI_FLAG, { isFetching: true });
    try {
      const response = await WgptEventAutomationsAPI.get();
      commit(types.SET_WGPT_EVENT_AUTOMATIONS, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_EVENT_AUTOMATIONS_UI_FLAG, { isFetching: false });
    }
    return null;
  },

  create: async ({ commit }, payload) => {
    commit(types.SET_WGPT_EVENT_AUTOMATIONS_UI_FLAG, { isCreating: true });
    try {
      const response = await WgptEventAutomationsAPI.create(payload);
      commit(types.ADD_WGPT_EVENT_AUTOMATION, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_EVENT_AUTOMATIONS_UI_FLAG, { isCreating: false });
    }
    return null;
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_WGPT_EVENT_AUTOMATIONS_UI_FLAG, { isUpdating: true });
    try {
      const response = await WgptEventAutomationsAPI.update(id, updateObj);
      commit(types.EDIT_WGPT_EVENT_AUTOMATION, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_EVENT_AUTOMATIONS_UI_FLAG, { isUpdating: false });
    }
    return null;
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_WGPT_EVENT_AUTOMATIONS_UI_FLAG, { isDeleting: true });
    try {
      await WgptEventAutomationsAPI.delete(id);
      commit(types.DELETE_WGPT_EVENT_AUTOMATION, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_EVENT_AUTOMATIONS_UI_FLAG, { isDeleting: false });
    }
    return null;
  },

  show: async ({ commit }, id) => {
    commit(types.SET_WGPT_EVENT_AUTOMATIONS_UI_FLAG, { isFetchingItem: true });
    try {
      const { data } = await WgptEventAutomationsAPI.show(id);
      commit(types.ADD_WGPT_EVENT_AUTOMATION, data);
      return data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_EVENT_AUTOMATIONS_UI_FLAG, {
        isFetchingItem: false,
      });
    }
    return null;
  },
};

export const mutations = {
  [types.SET_WGPT_EVENT_AUTOMATIONS_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_WGPT_EVENT_AUTOMATIONS]: MutationHelpers.set,
  [types.ADD_WGPT_EVENT_AUTOMATION]: MutationHelpers.setSingleRecord,
  [types.EDIT_WGPT_EVENT_AUTOMATION]: MutationHelpers.update,
  [types.DELETE_WGPT_EVENT_AUTOMATION]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
